import React from 'react'
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import classNames from "classnames";

import makeStyles from "@mui/styles/makeStyles";

import DownloadShipmentFile from "./DownloadShipmentFile";

import {lighterBlack} from "assets/jss/main";
import PrintButton from "./PrintButton";
import ReturnTrackingNumber from "./ReturnTrackingNumber";
import TrackingNumberItem from "./TrackingNumberItem";

const useStyle = makeStyles({
    trackingNumbers: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'end',
    },
    title: {
        fontSize: '16px',
        color: lighterBlack,
        fontWeight: 400,
        display: 'flex',
        letterSpacing: '0.192px',
    },
    number: {
        color: lighterBlack,
        fontWeight: 'bold',
        '&:visited': {
            color: lighterBlack,
        }
    },
    numberUnderline: {
        textDecoration: 'underline',
    },
});

export default function TrackingNumbers({trackingNumber, shipment, currentOrganization, returnShipments}) {
    const classes = useStyle();

    const shipmentLabels = shipment.documents ? Object.values(shipment.documents).filter(item => item['type'] === "waybill") : null;
    const shipmentLabel = shipmentLabels && shipmentLabels.length ? shipmentLabels[0]['url'] : null;
    const trackingUrl = shipment && shipment.trackingUrl ? shipment.trackingUrl : null;

    const returnForms = shipment.documents ? Object.values(shipment.documents).filter(item => item['type'] === "return-form") : null;
    const returnForm = returnForms && returnForms.length ? returnForms[0]['url'] : null;

    const parcels = (shipment.parcels || []).filter(parcel => parcel.trackingNumber);

    return (
        <div className={classes.trackingNumbers}>
            {trackingNumber && (
                <TrackingNumberItem
                    trackingNumber={trackingNumber}
                    document={shipmentLabels[0]}
                    documentUrl={shipmentLabel}
                    trackingUrl={trackingUrl}
                    currentOrganization={currentOrganization}
                />
            )}

            {!trackingNumber && parcels.length > 0 && parcels.map((parcel, index) => (
                <TrackingNumberItem
                    key={parcel.id || index}
                    trackingNumber={parcel.trackingNumber}
                    trackingUrl={parcel.trackingUrl || null}
                    currentOrganization={currentOrganization}
                    type="parcel"
                    index={parcels.length > 1 ? (index + 1) : null}
                />
            ))}

            {returnShipments.map((returnShipment, index) => (
                <ReturnTrackingNumber
                    key={index}
                    index={returnShipments.length > 1 ? (index + 1): null}
                    returnShipment={returnShipment}
                    currentOrganization={currentOrganization}
                />
            ))}

            {returnForm && (
                <span className={classes.title}>
                    <a href={returnForm} className={classNames(classes.number, classes.numberUnderline)}>
                         <FormattedMessage id={'picking.order.shipments.header.trackingNumber.return-form'} />
                    </a>
                    <DownloadShipmentFile shipmentLabelLink={returnForm} />
                    {currentOrganization.printNodeKey &&
                        <PrintButton shipmentDocument={returnForms[0]} currentOrganization={currentOrganization}></PrintButton>
                    }
                </span>
            )}
        </div>
    )
}

TrackingNumbers.defaultProps = {
    trackingNumber: '',
    returnTrackingNumber: '',
    shipmentLabel: '',
    returnShipmentLabel: ''
}

TrackingNumbers.propTypes = {
    trackingNumber: PropTypes.string,
    returnTrackingNumber: PropTypes.string,
    shipmentLabel: PropTypes.string,
    returnShipmentLabel: PropTypes.string
}
